<script setup>
// IMPORTS

import AppLayoutTopBar from "@/shared/layout/AppLayoutTopBar.vue";

// DEPENDENCIES
const { mode, isMainNavOpen } = useApp();

// const authStore = useAuthStore();

// INJECT

// PROPS, EMITS

// REFS

// COMPUTED

// COMPONENT METHODS AND LOGIC

// PROVIDE, EXPOSE

// WATCHERS

// LIFECYCLE METHODS (https://vuejs.org/api/composition-api-lifecycle.html)
</script>

<template>
  <AppLayoutTopBar />
  <div
    class="navbar"
    :class="{ 'is-open': isMainNavOpen }"
  >
    <FMMainNav />
  </div>
  <div
    class="admin-panel"
    :class="{ 'is-editor': mode === 'editor' }"
  >
    <main class="main-wrapper">
      <router-view v-slot="{ Component }">
        <!-- <transition name="fade" mode="out-in"> -->
        <component :is="Component" />
        <!-- </transition> -->
      </router-view>
    </main>
  </div>

  <!-- why is this here? https://stackoverflow.com/questions/74525054/primevue-confirmdialog-opens-multiple-times -->
  <ConfirmDialog
    group="remove-editor-item"
    class="border-none"
  >
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="bg-dark-gray-2000 flex flex-col rounded-sm border-none p-4 text-white">
        <span class="mt-6 mb-2 block text-2xl font-bold">
          {{ message.header }}
        </span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="mt-6 flex items-center gap-2">
          <Button
            label="Delete"
            severity="danger"
            @click="acceptCallback"
          />
          <Button
            label="Keep"
            outlined
            severity="secondary"
            class="text-white hover:text-gray-900"
            @click="rejectCallback"
          />
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>
<style scoped lang="scss">
$navbar-width: 200px;
$topbar-height: 60px;
$navbar-editor-width: 120px;

.navbar {
  width: $navbar-width;
  top: $topbar-height;
  position: fixed;
  left: 0;
  height: 100%;
  z-index: 31;
  transform: translateX(-100%);
  transition: transform 0.3s;

  &.is-open {
    transform: translateX(0);
  }
}

.main-wrapper {
  background-color: var(--color-dark-gray-2050);
  overflow: hidden;
  margin-left: $navbar-width;
  margin-top: $topbar-height;
  height: 100%;
  width: calc(100% - $navbar-width);
  transition: background-color 0.1s ease-in-out;
  transition-delay: 0.3s;
  overflow-y: auto;
}

.is-editor {
  .main-wrapper {
    background-color: var(--color-turquoise-50);
    margin-left: $navbar-editor-width;
    width: 100%;
    width: calc(100% - $navbar-editor-width);
  }
}

// Page transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
